<template>
  <div class="produk">
    <!-- <SearchView />    -->
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row text-white" style="padding: 15px 110px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Produk Favorit
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Produk Favorit" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
        <div class="row text-white" style="padding: 10px 20px;">
        <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 700;">
          Produk Favorit
        </div>
        <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Produk Favorit" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div style="margin: 50px 100px" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row" style="margin-bottom: 15px;">
        <div class="col-12 col-md-12">
          <div class="row items-start q-col-gutter-md" style="margin-bottom: 50px;">
            <div class="col-12 col-md-3" v-for="data in list_data">
              <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.produk_id)">
                <q-img :src="file_path+data.produk_file" height="275px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>

                <q-card-section style="text-align: center;">
                      <q-btn
                        round
                        color="white"
                        icon="shopping_cart"
                        text-color="purple-12"
                        size="sm"
                        style="top: -15px; transform: translateY(-50%);"
                      />
                      <div class="produk-cat">
                        {{data.kategori_uraian}}
                      </div>
                      <div style="padding-bottom: 15px;">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="1em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                      />
                      </div>
                      <q-btn no-caps flat @click="push_produk(data.produk_id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.produk_nama" />
                      <div class="produk-price1">Rp. {{data.produk_harga}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                    </q-card-section>
                
              </q-card>
            </div>
          </div>
          <div class="q-pa-lg flex flex-center">
              <q-btn @click="btn_prev" round outline size="sm" color="purple-12" icon="chevron_left" />
              <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
              <q-btn @click="btn_next" round outline size="sm" color="purple-12" icon="chevron_right" />
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 25px 20px" v-if="$q.screen.lt.sm">
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="row items-start q-col-gutter-xs" style="margin-bottom: 25px;">
            <div class="col-3" v-for="data in list_data">
              <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.produk_id)">
                <q-img :src="file_path+data.produk_file" height="100px">
                  <template v-slot:loading>
                    <div class="text-purple-12">
                      <q-spinner-ios />
                    </div>
                  </template>
                </q-img>

                <q-card-section style="text-align: center;">
                      <q-btn
                        round
                        color="white"
                        icon="shopping_cart"
                        text-color="purple-12"
                        size="xs"
                        style="top: -15px; transform: translateY(-50%);"
                      />
                      <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                        {{data.kategori_uraian}}
                      </div>
                      <div style="margin-top: -5px;">
                        <q-rating
                        v-model="model1"
                        max="5"
                        size="0.5em"
                        color="purple-12"
                        icon="star_border"
                        icon-selected="star"
                        icon-half="star_half"
                      />
                      </div>
                      <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.produk_nama }}
                      </div>
                      <div class="produk-price1-android">Rp. {{data.produk_harga}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.produk_harga}}</span></div>
                    </q-card-section>
                
              </q-card>
            </div>
          </div>
          <div class="q-pa-xs flex flex-center">
              <q-btn @click="btn_prev" round outline size="xs" color="purple-12" icon="chevron_left" />
              <span class="h_pagination-android">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
              <q-btn @click="btn_next" round outline size="xs" color="purple-12" icon="chevron_right" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ref } from 'vue'
// import SearchView from '@/views/SearchView.vue'

export default {
  name: 'ProdukView',
  // components: {
  //   SearchView
  // },
  data () {
    return {
      tabs: ref('all'),
      list_data : [],
      model1: '3.5',

      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,

      hal_first : 1,
      hal_last : 2,
      cari_value: "",
    }
  },
  methods: {
    push_produk : function(id){
      this.$router.push('/produk_detail/'+id);
    },

    // getView : function(){
    //   this.$store.commit('showLoading');
    //   fetch(this.$store.state.url.URL_WISHLIST  + "view", {
    //       method: "POST",
    //       headers: {
    //       "content-type": "application/json"
    //       },
    //       body: JSON.stringify({
    //           data_ke: this.page_first
    //       })
    //   })
    //       .then(res => res.json())
    //       .then(res_data => {
    //           this.list_data = res_data.data;
    //           this.page_last = res_data.jml_data;
    //           this.$store.commit("hideLoading");
    //           console.log(res_data);
    //   });
    // },

    getView : function(){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_WISHLIST  + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(this.list_data);
      });
    },

    getProduk : function(a){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_PRODUK+"produk", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
          body: JSON.stringify({
              data_ke: this.hal_first,
              kategoriId : a,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_produk = res_data.data;
              this.hal_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    getKategori : function (){
      fetch(this.$store.state.url.URL_BERANDA + "listKategori", {
        method: "GET",
        headers: {
          "content-type": "application/json"
        },
      })
      .then(res => res.json())
      .then(res_data => {
        this.list_kategori = res_data;
        console.log(this.list_kategori)
      });
    },
    // ====================================== PAGINATE ====================================

        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        tombol_prev : function(a){
            this.cek_load_data = true;
            if(this.hal_first>1){
                this.hal_first--
            }else{
                this.hal_first = 1;
            }
            this.getProduk(a);
        },

        tombol_next : function(a){
            if(this.hal_first >= this.hal_last){
                this.hal_first == this.hal_last
            }else{
                this.hal_first++;
            }
            this.getProduk(a);
        },
        
        pageTabs(a){
          this.hal_first = 1;
          this.getProduk(a);
        },

        cari_data : function(){
          this.page_first = 1;
          this.getView();
        },

    // ====================================== PAGINATE ====================================
  },
  mounted() {
    this.getView();
    this.getKategori();
  }
}
</script>
